export default __webpack_public_path__ + "static/media/46.c7f812d7.jpeg";